import config from '../config';
import {GiftCardData} from '../giftCardShop/screens/schema';
import {AirtablePromotionItem} from '../models/airtable';
import {AppRoute} from '../models/AppRoute';
import {ZenGiftCardsPaymentInstrument} from '../models/mfl';
import {GiftCardRecipientData, Shop, Voucher} from '../models/middleware';
import {rootStore} from '../stores/rootStore';

import {toLocalISOString} from './date';

export type ZenGiftCardsPaymentInstrumentWithChargedAmount =
  ZenGiftCardsPaymentInstrument & {
    chargedAmount: number; // cents
  };

const makePlaceholderShop = (storeNumber: string): Shop => ({
  id: 'placeholder',
  name: 'placeholder',
  phone: 'placeholder',
  store_number: storeNumber,
  address: {
    lines: ['placeholder'],
    postal_code: 'placeholder',
    administrative_area: 'placeholder',
    locality: 'placeholder',
  },
  delivery_available: true,
  pickup_available: true,
  distance: 0,
  openToday: null,
  shop_role: 'placeholder',
});

export const navigateToGiftCardsShop = async () => {
  const selectedStoreId =
    rootStore.shopSelectionStore.selectedStore?.store_number;
  if (selectedStoreId) {
    await rootStore.shopSelectionStore.setLiquorShopSalesforceIdToStorage(
      selectedStoreId,
    );
  }
  const placeholderGiftCardShop: Shop = makePlaceholderShop(
    config.GIFT_CARD_STORE,
  );
  await rootStore.shopSelectionStore.selectStore(placeholderGiftCardShop);
};

export const makeGiftCardRecipientData = (
  values: GiftCardData,
): GiftCardRecipientData => ({
  note: values.note,
  recipient_name: values.recipientName,
  recipient_email_address: values.recipientEmail,
  recipient_phone_number: values.recipientPhoneNumber,
  gift_email_date: toLocalISOString(values.deliveryDate),
});

export const navigateToLiquorShop = async (navigation: any) => {
  let localStorageLiquorStore =
    await rootStore.shopSelectionStore.loadLiquorShopSalesforceIdFromLocalStorage();

  // TODO: hack for old buggy dev versions
  if (localStorageLiquorStore === config.GIFT_CARD_STORE) {
    localStorageLiquorStore = null;
    await rootStore.shopSelectionStore.clearLiquorShopSalesforceIdFromStorage();
  }

  if (localStorageLiquorStore) {
    const placeholderLiquorShop: Shop = makePlaceholderShop(
      localStorageLiquorStore,
    );
    await rootStore.shopSelectionStore.selectStore(placeholderLiquorShop);
  } else {
    navigation.navigate(AppRoute.MY_STORE_SUBURB_SELECTION);
  }
};

export const navigateToPreviousStore = () =>
  rootStore.shopSelectionStore.selectPreviousStore();

export const isGiftCardsPromotion = (promotion: AirtablePromotionItem) =>
  promotion.activationUrlName === config.GIFT_CARDS_PROMOTION_ID;

export const getGiftCardRemainingBalance = (giftCard: Voucher) =>
  parseFloat(giftCard.vouchervalue) - parseFloat(giftCard.valueused);

// :/
export const isGiftCardProduct = (product: {
  name: string;
  brand_name: string;
}) =>
  product.name.toLowerCase().includes('gift card') &&
  product.brand_name === 'Liquor Marketing Group';
